"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelbianco": {
    "685e430d": [{
      "hkey": "98d50a80",
      "slug": "colletta-magliocca",
      "name": "Colletta-Magliocca",
      "primary": true,
      "skipSearch": false
    }],
    "colletta": [{
      "hkey": "98d50a80",
      "slug": "colletta-magliocca",
      "name": "Colletta-Magliocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;